// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610052145/js/" + chunkId + "." + {"44":"e94709de","225":"69f4a305","481":"1e951910","486":"6cec3418","770":"5698684c"}[chunkId] + ".0.7938506933509777.chunk.js";
};